// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__1A99E","ordering":"styles_ordering__I6l4e","number":"styles_number__2smUu"};